import { render, staticRenderFns } from "./MessageTemplateList.vue?vue&type=template&id=11952cf4"
import script from "./MessageTemplateList.vue?vue&type=script&lang=js"
export * from "./MessageTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports